<section *ngIf="isMobile$ | async as isMobile" class="destination-search-bar dn-tablet-up">
  <button
    class="fill flex flex--no-wrap flex--center rounded-medium ps-small-x font-body-1 white-bg border nordic-blue-400-border"
    [attr.aria-label]="{ label: 'siteSearch.search' | finLocalization, role: 'button' }"
    (click)="openModal($event)"
    data-testid="destinations-search-bar-button"
  >
    <fcom-icon [name]="SvgLibraryIcon.SEARCH" class="rotate icon-small ms-xxsmall-r flex flex--self-center"></fcom-icon>
    <span class="ps-small-y">{{ 'siteSearch.search' | finLocalization }}</span>
  </button>

  <div class="search-bar-overlay fixed" fcomTrapFocus *ngIf="isVisible$ | async">
    <div
      class="modal block fixed"
      [attr.aria-labelledby]="'search-bar-siteSearch-title'"
      role="dialog"
      aria-modal="true"
    >
      <div class="grow flex flex--column white-bg" data-testid="destinations-options-list-container">
        <header
          class="flex--nogrow flex--basis-header flex flex--column flex--center fill relative border-bottom ps-small"
        >
          <div class="flex flex--row flex--center fill ps-small-b">
            <h3 class="font-heading-3 flex-1 mr-clear-y truncate overflow-hidden nordic-blue-900-text">
              {{ 'destinationSearch.text' | finLocalization }}
            </h3>
            <button
              (click)="closeOptionsList()"
              [attr.title]="'actions.close' | finLocalization"
              [attr.aria-label]="'actions.close' | finLocalization"
              class="flex--nogrow flex--self-stretch btn--no-outline focus-inset"
            >
              <fcom-icon [name]="SvgLibraryIcon.CLOSE_DELETE"></fcom-icon>
            </button>
          </div>
          <ng-container *ngTemplateOutlet="searchBar; context: { isMobile }"></ng-container>
        </header>
        <div *ngIf="optionsListVisible$ | async" class="scroll relative">
          <div *ngIf="!destinationInput?.value" class="flex flex--wrap ps-small-x ps-small-b">
            <fcom-tag-button
              class="ps-small-t"
              [class.ps-small-r]="!last"
              id="{{ continent.id }}"
              [text]="continent.title + ' (' + continent.count + ')'"
              [title]="('actions.remove' | finLocalization) + ' ' + continent.title"
              [theme]="(selectedContinent$ | async)?.id === continent?.id ? TagTheme.ACTIVE : TagTheme.DEFAULT"
              (tagClicked)="selectedContinent$.next(continent)"
              tabindex="-1"
              *ngFor="let continent of continents$ | async; let last = last; trackBy: trackByFn"
              data-testid="destinations-continent-chip"
            >
            </fcom-tag-button>
          </div>
          <ng-container *ngTemplateOutlet="searchBarContent"></ng-container>
        </div>
        <footer
          *ngIf="selectedDestinations?.length"
          class="flex flex--nogrow flex--row-reverse flex--middle nordic-blue-25-bg"
        >
          <ng-container *ngTemplateOutlet="searchBarSelections"></ng-container>
        </footer>
      </div>
    </div>
  </div>
</section>

<section
  *ngIf="(isMobile$ | async) === false"
  class="destination-search-bar dn-tablet-down"
  (fcomClickOutside)="closeOptionsList()"
>
  <div
    class="relative grow"
    (keydown.esc)="closeOptionsList()"
    (focusout)="handleComponentFocusOut($event)"
    data-testid="search-bar-container"
  >
    <ng-container *ngTemplateOutlet="searchBar; context: { isMobile: false }"></ng-container>
    <div
      [hidden]="(optionsListVisible$ | async) === false"
      class="absolute z5 fill white-bg mr-xxsmall-t rounded-large shadow-highlight"
      data-testid="destinations-options-list-container"
    >
      <div class="search-bar-wrapper relative scroll">
        <div *ngIf="!destinationInput?.value" class="flex flex--wrap white-bg rounded-large ps-small-b ps-small-x">
          <fcom-tag-button
            class="ps-small-t"
            [class.ps-small-r]="!last"
            id="{{ continent.id }}"
            [text]="continent.title + ' (' + continent.count + ')'"
            [title]="('actions.select' | finLocalization) + ' ' + continent.title"
            [theme]="(selectedContinent$ | async)?.id === continent?.id ? TagTheme.ACTIVE : TagTheme.DEFAULT"
            (tagClicked)="selectedContinent$.next(continent)"
            tabindex="-1"
            *ngFor="let continent of continents$ | async; let last = last; trackBy: trackByFn"
            [attr.data-testid]="'destinations-continent-chip-' + continent.id"
          >
          </fcom-tag-button>
        </div>

        <ng-container *ngTemplateOutlet="searchBarContent"></ng-container>
      </div>

      <div
        *ngIf="selectedDestinations?.length"
        class="fill flex flex--row-reverse flex--middle rounded-bottom-large nordic-blue-50-bg"
      >
        <ng-container *ngTemplateOutlet="searchBarSelections"></ng-container>
      </div>
    </div>
  </div>
</section>

<ng-template #searchBar let-isMobile="isMobile">
  <div
    class="flex flex--row flex--center fill input relative rounded-large"
    [class.input--focused]="inputHasFocus"
    [class.input--has-query]="inputField.value"
    [class.z5]="optionsListVisible$ | async"
    (click)="onClickInputArea($event, isMobile)"
  >
    <input
      type="text"
      role="combobox"
      id="to-field-combobox"
      placeholder="{{ 'destinationSearch.input.placeholder' | finLocalization }}"
      [attr.aria-expanded]="optionsListVisible$ | async"
      aria-autocomplete="list"
      aria-controls="to-field-listbox"
      aria-owns="to-field-listbox"
      aria-haspopup="listbox"
      autocomplete="off"
      [formControl]="destinationInput"
      class="fill no-outline absolute block rounded-large ps-small-l font-body-1 regular-type"
      (focus)="openOptionsList(isMobile)"
      #inputField
    />
    <button
      class="input-icon block absolute"
      tabindex="-1"
      [attr.aria-expanded]="optionsListVisible$ | async"
      aria-controls="to-field-listbox"
      data-testid="destination-search-to-input-button"
      #inputFieldButton
    >
      <fcom-icon
        *ngIf="(isStartTyping$ | async) === false"
        class="icon-medium"
        [name]="SvgLibraryIcon.SEARCH"
      ></fcom-icon>
      <fcom-icon
        *ngIf="isStartTyping$ | async"
        [name]="isMobile ? SvgLibraryIcon.TRASH : SvgLibraryIcon.CLOSE_DELETE"
      ></fcom-icon>
    </button>
  </div>
</ng-template>

<ng-template #searchBarContent>
  <ul
    role="listbox"
    aria-multiselectable="true"
    id="to-field-listbox"
    data-testid="destination-search-results"
    class="no-list-style relative listbox"
    tabindex="-1"
    #optionsListbox
  >
    <ng-container *ngFor="let destination of matchingDestinations$ | async; index as i; trackBy: trackByFn">
      <ng-container *ngIf="destination.type === DESTINATION_TYPE.CONTINENT">
        <ng-container *ngFor="let country of destination.items; trackBy: trackByFn">
          <li class="country" [attr.data-testid]="'destination-search-' + country.countryCode">
            <fin-expand
              [id]="country.countryCode"
              [key]="country.countryCode"
              [clearSelectionOnDestroy]="true"
              class="block"
              #expand
            >
              <div
                class="trigger flex flex--space-between border-bottom ps-small bold-type"
                [class.bold-type]="country.type === DESTINATION_TYPE.COUNTRY"
                [class.border-bottom]="(expand.isOpen$ | async) === false"
              >
                <span class="nordic-blue-900-text"> {{ country.title }} ({{ country.count }}) </span>
                <fcom-icon
                  class="rotate icon-medium"
                  [class.rotate-active]="expand.isOpen$ | async"
                  [name]="SvgLibraryIcon.CHEVRON_DOWN"
                ></fcom-icon>
              </div>
              <div class="content ps-small-b">
                <ul class="flex flex--column">
                  <ng-container
                    *ngTemplateOutlet="destinationTemplate; context: { destination: country }"
                  ></ng-container>
                </ul>
              </div>
            </fin-expand>
          </li>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="destination.type !== DESTINATION_TYPE.CONTINENT">
        <ng-container
          *ngTemplateOutlet="destinationTemplate; context: { destination: destination, index: i }"
        ></ng-container>
      </ng-container>
    </ng-container>
    <li
      *ngIf="(matchingDestinations$ | async)?.length === 0"
      class="ps-medium-x inactive"
      data-testid="no-matching-destination"
    >
      <div class="ps-small-y">
        <span>
          {{ 'destinationSearch.noMatches' | finLocalization }}
        </span>
      </div>
    </li>
  </ul>
</ng-template>

<ng-template #destinationTemplate let-destination="destination" let-index="index">
  <ng-container *ngIf="destination.type === DESTINATION_TYPE.COUNTRY">
    <li
      *ngIf="destination?.items?.length > 1"
      class="flex flex--column ps-small all"
      [id]="'to-field-option-all'"
      role="option"
      (click)="toggleDestinationSelection(destination)"
      (keydown)="toggleDestinationByKeyboard($event, destination)"
    >
      <fcom-checkbox
        [name]="destination.countryCode + '-all'"
        [cid]="destination.countryCode + '-all'"
        [checked]="destinationIsSelected(destination)"
      >
        <span class="font-body-1 medium-type">{{
          'destinationSearch.selectAll' | finLocalization: { country: destination.title }
        }}</span>
      </fcom-checkbox>
    </li>
    <ng-container *ngFor="let dest of destination?.items; let last = last; trackBy: trackByFn">
      <li
        class="flex flex--column ps-small-y"
        [class.ps-small-x]="destination?.items?.length === 1"
        [class.ms-xlarge-x]="destination?.items?.length > 1"
        [class.border-bottom]="!last"
        [id]="'to-field-option-' + dest.locationCode"
        [attr.data-testid]="'to-field-option-' + dest.locationCode"
        role="option"
        (click)="toggleDestinationSelection(dest, destination)"
        (keydown)="toggleDestinationByKeyboard($event, dest, destination)"
      >
        <fcom-checkbox
          [name]="dest.countryCode + '-' + dest.locationCode"
          [cid]="dest.locationCode"
          [checked]="destinationIsSelected(dest)"
        >
          <span class="font-body-1 medium-type">{{ dest.title }}</span>
        </fcom-checkbox>
      </li>
    </ng-container>
  </ng-container>
  <ng-container *ngIf="destination.matchesQuery">
    <li
      role="option"
      [id]="'to-field-option-' + index"
      [attr.aria-selected]="destinationIsSelected(destination) ? 'true' : 'false'"
      (click)="toggleDestinationSelection(destination)"
      (keydown)="toggleDestinationByKeyboard($event, destination)"
      class="flex flex--column ps-medium-y ps-small-x border-bottom"
    >
      <fcom-checkbox
        [name]="destination.title"
        [cid]="destination.title"
        [checked]="destinationIsSelected(destination)"
      >
        <span class="font-body-1 medium-type"
          >{{ destination.title }},
          {{ destination.type === DESTINATION_TYPE.COUNTRY ? destination.continent : destination.country }}</span
        >
      </fcom-checkbox>
    </li>
  </ng-container>
</ng-template>

<ng-template #searchBarSelections>
  <fcom-button
    class="showResults flex--self-end ps-small ps-medium-l"
    [theme]="ButtonTheme.LIGHT_PRIMARY_CTA_HEATHER"
    [text]="'destinationSearch.show' | finLocalization"
    (clickBtn)="closeOptionsList()"
    #showResultsButton
    data-testid="destination-search-show-results"
  ></fcom-button>
  <div class="flex-4" [class.ps-small-t]="selectedDestinations.length < 3">
    <div class="font-body-1 regular-type ps-small-l">
      <span class="ps-xsmall-r" data-testid="destination-search-selected-destinations">
        {{
          'destinationSearch.selectedDestination.' + (selectedDestinations.length === 1 ? 'singular' : 'plural')
            | finLocalization: { total: selectedDestinations.length }
        }}</span
      >
      <ng-container *ngIf="selectedDestinations.length >= 3">
        <button
          id="remove-all"
          class="btn btn--no-outline nordic-blue-900-text underline font-body-1 ps-xsmall-y"
          (click)="removeAll()"
          data-testid="destination-search-remove-all"
        >
          {{ 'destinationSearch.chip.action.removeAll' | finLocalization }}
        </button>
      </ng-container>
    </div>
    <ng-container *ngIf="selectedDestinations.length < 3">
      <ul class="selectedChips selections no-list-style flex flex--wrap ps-small" #tagList>
        <li *ngFor="let item of selectedDestinations; let i = index; trackBy: trackByFn" class="ms-xsmall-r">
          <fcom-tag-button
            id="{{ item.id }}"
            [text]="item.title"
            [title]="('actions.remove' | finLocalization) + ' ' + item.title"
            [iconName]="SvgLibraryIcon.CLOSE_DELETE"
            [theme]="TagTheme.ACTIVE"
            (tagClicked)="removeTag(item)"
            tabindex="-1"
          >
          </fcom-tag-button>
        </li>
      </ul>
    </ng-container>
  </div>
</ng-template>
